import en from '@/i18n/en.json'
import cn from '@/i18n/cn.json'
import kz from '@/i18n/kz.json'
import ru from '@/i18n/ru.json'



export const defaultLocale = 'ru'

export const languages = {
    ru, en, cn, kz
}